import { getReferralsApiUrl } from '../config/api';
import { sanitizeWorkflowPayload } from '../lib/smartFill/sanitizeWorkflowPayload';
const LOG_PREFIX = '[smart-fill]';
export class SmartFillError extends Error {
    constructor(message, debug) {
        super(message);
        Object.defineProperty(this, "debug", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'SmartFillError';
        this.debug = debug;
    }
}
function logSmartFill(step, data) {
    if (process.env.NODE_ENV === 'production')
        return;
    if (data !== undefined) {
        console.log(LOG_PREFIX, step, data);
    }
    else {
        console.log(LOG_PREFIX, step);
    }
}
function mapServerDebug(apiPath, serverDebug) {
    return {
        url: getReferralsApiUrl(apiPath),
        httpStatus: serverDebug.httpStatus,
        request: serverDebug.request,
        response: serverDebug.response,
    };
}
async function postReferralApi(apiPath, body) {
    const url = getReferralsApiUrl(apiPath);
    const debug = {
        url,
        httpStatus: 0,
        request: body ?? {},
        response: null,
    };
    logSmartFill('request', { url, body });
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    debug.httpStatus = response.status;
    const rawText = await response.text();
    logSmartFill('response raw', rawText.slice(0, 500));
    let payload;
    try {
        payload = JSON.parse(rawText);
        debug.response = payload;
    }
    catch {
        debug.response = rawText;
        throw new SmartFillError(`Invalid JSON response (${response.status}): ${rawText.slice(0, 200)}`, debug);
    }
    if (payload.debug) {
        Object.assign(debug, mapServerDebug(apiPath, payload.debug));
    }
    if (!response.ok || payload.error) {
        throw new SmartFillError(payload.error ?? `Request failed (${response.status})`, debug);
    }
    if (!payload.result) {
        throw new SmartFillError('API response did not include result', debug);
    }
    const serverResultDebug = payload.result.debug;
    return {
        ...payload.result,
        debug: serverResultDebug ? mapServerDebug(apiPath, serverResultDebug) : debug,
    };
}
export async function runSmartFill(request) {
    return postReferralApi('/referrals/smart-fill', sanitizeWorkflowPayload(request));
}
export async function runDocumentParse(request) {
    return postReferralApi('/referrals/document-parse', sanitizeWorkflowPayload(request));
}
